import { Button } from '@sc/shared-ui';
import { ReactElement } from 'react';
import StarkLogo from '../assets/brand/logo.svg';

interface IntegrationOption {
  name: string;
  logo: HeroIconType;
  description: string;
  oAuthUrl: string;
}

interface Props {
  integration: IntegrationOption;
  onConnect?: (() => void) | undefined;
}

export const ConnectIntegration = ({
  integration,
  onConnect,
}: Props): ReactElement => {
  const Logo = integration.logo;

  return (
    <div className="flex flex-col items-center justify-center h-full w-full p-10 text-center space-y-6">
      <div className="flex items-center justify-center">
        <div className="border border-grey-t-800 p-3.5 h-fit flex items-center justify-center rounded-xs">
          <StarkLogo className="size-7" />
        </div>
        <div className="w-12 border-t border-dashed border-grey-t-700" />
        <div className="border border-grey-t-800 p-3.5 h-fit flex items-center justify-center rounded-xs">
          <Logo className="size-7" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="font-grotesque font-bold text-h3">
          Connect {integration.name}
        </h2>
        <p className="text-text-low-priority">{integration.description}</p>
      </div>
      <Button
        button={{
          type: 'basic',
          text: `Connect ${integration.name}`,
          shrink: true,
          onClick: onConnect,
        }}
        link={{
          href: integration.oAuthUrl,
        }}
      />
    </div>
  );
};
